/* global window */
import { isAnyMobileDevice } from "../../utils/user-agent";
var POPUP_WIDTH = 700;
var POPUP_HEIGHT = 700;

var getWindowFeatures = function getWindowFeatures() {
  // on mobile popup should be full screen
  if (isAnyMobileDevice) return '';
  return ["height=".concat(POPUP_HEIGHT), "width=".concat(POPUP_WIDTH), "top=".concat(Math.floor((window.screen.height - POPUP_HEIGHT) / 2)), "left=".concat(Math.floor((window.screen.width - POPUP_WIDTH) / 2))].join(', ');
};
/**
 * @param {string} state arbitrary string value that will be passed as state param to Apple Sign in
 */


export var openPopup = function openPopup(state) {
  return window.open("/home/apple-signin/interstitial.html?state=".concat(state), 'appleAuthPopup', getWindowFeatures());
};